<template>
  <portlet
          :icon="'fad fa-users'"
          :title="'Gebruikers'"
          :actionsBlock="true"
  >
    <template v-if="Can(rights.USER_ADD)" slot="actionsBlock">
      <router-link tag="button" :to="{name:'user-create'}" class="btn btn-secondary btn-add-user">
        <i class="fas fa-plus-circle mr-2"></i> Toevoegen
      </router-link>
    </template>
    <template slot="portletBody">
       <datatables
        v-if="users.length && renderedComponent && Can(rights.USER_VIEW)"
        :tableClass="tableClass"
        tableID="users"
        :rows="users"
        :columns="getColumns()"
        :tableInitOptions="tableInitOptions"
        routerLinkClass="dt-router-link"
        :deleteFunction="deleteUser"
        deleteClass="delete"
        :customFilters="customFilters"
        @rowSelected="rowSelected"
      ></datatables>
       <edit-user
        v-if="user"
        :title="'Edit User'"
        :user="user"
        :name="'user-'+modalId"
        :roles="getRoles"
        @saveChanges="editUser($event)"
      >
      </edit-user>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import editUser from '../../components/users/editUser.vue';
  import firebase from 'firebase/app';
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from '../roles/rights';
  import { buildHourAppUserPayload } from '../../utils/userSync';
  import { describeHourAppSyncOutcome } from '@/utils/placementSync';

  export default {
  components: { editUser },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: '',
        isAdmin: false,
        users: [],
        user: null,
        nextPageToken: null,
        customFilters: [],
        modalId: null,
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
     await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)
     await   store.dispatch('users/getAllUsers', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            console.log(res.data)
            this.users = res.data.users.filter(user => user.hasOwnProperty('email'));
            this.nextPageToken = res.nextToken;
            this.$store.commit('setLoading',false)
          }
        }).catch((err) => {
          this.$store.commit('setLoading',false)

        });

          this.$store.commit('setLoading',false)
      },
      rowSelected(value) {
          this.modalId = value.id;
          this.user = value;
      },
      editUser(user) {
        if (user.email) {
            let id = user.id;
            let updatedUser = {
                firstname: user.firstname,
                lastname: user.lastname,
                mobile: user.mobile,
                email: user.email,
                roles: user.roles,
                departments: user.departments,
            }

            var db = firebase.firestore();

            db.collection("UserData").where("id", "==", id).get().then((results) => {
              db.collection("UserData").doc(results.docs[0].id).update(updatedUser).then(() => {
                this.syncAdminLikeUserToHourApp(user);
                this.$toasted.global.successRequest({
                  message: 'Gebruiker aangepast',
                });
                $('.modal').modal('hide');
                $('.modal-backdrop').remove();
              }).catch((error) => {
                this.$toasted.global.failedRequest({
                  message: 'Something went wrong',
                });
                $('.modal').modal('hide');
                $('.modal-backdrop').remove();
              });
            }).catch((error) => {
              this.$toasted.global.failedRequest({
                message: 'Something went wrong',
              });
              $('.modal').modal('hide');
              $('.modal-backdrop').remove();
            });


            this.renderComponent();
        }
      },
      syncAdminLikeUserToHourApp(user) {
        const payload = buildHourAppUserPayload(user);
        if (payload === null) return;
        store.dispatch('users/postUserHourApp', {ApiClient: Vue.prototype.$ApiClient, user: payload}).then((res) => {
          const outcome = describeHourAppSyncOutcome(res);

          if (!outcome.ok) {
            this.$toasted.global.failedRequest({message: 'Urenapp: ' + outcome.message});
          }
        });
      },
      deleteUser(user) {
        store.dispatch('users/deleteUser', {ApiClient: Vue.prototype.$ApiClient, user: user}).then((res) => {
          this.$toasted.global.successRequest({
            message: 'Gebruiker verwijderd'
          });
          this.fetchData();
          this.user = {};
        }).catch((err) => {
          this.$toasted.global.failedRequest();
        });
      },
      getColumns() {
        let self = this;
        return [
          {data: 'email', name: 'Email', visible: true, searchable: true},
          {data: 'firstname', name: 'Voornaam', visible: true, searchable: true},
          {data: 'lastname', name: 'Achternaam', visible: true, searchable: true},
          {data: null, name: 'Vestiging', visible: true, searchable: true,
          render(data) {
            if(data.departments){
              return _.map(data.departments, d=>{
                return d.name + ' '
              })
            }
              return ''
            }
          },
          {
            data: null, name: 'Opties', orderable: false, responsivePriority: 2,
            render(data) {
              var options = '';
              if(Can(RIGHTS.USER_EDIT)) {
                  options += '<i title="Gebruiker aanpassen" class="far fa-edit action-icon get-data" data-target="#user-' + data.id + '" data-toggle="modal"></i>';
              }

              if(Can(RIGHTS.USER_DELETE)) {
                  options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              }
              return options;
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
    },
  };
</script>
